import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

/**
 * Undefined means the app is intentionally running in local demo mode.
 * Never place a service-role key in a VITE_ variable.
 */
export const supabase = url && anonKey ? createClient(url, anonKey) : undefined;
export const isSupabaseConfigured = Boolean(supabase);
